export default {
  scheduleId: {
    type: String,
    required: true
  }
}



// WEBPACK FOOTER //
// ./src/app/patient/dashboard/gadget/components/upcoming/components/event-details/resources/props.js